import { render, staticRenderFns } from "./SyllabusProgressDisplay.vue?vue&type=template&id=d3ecb84c&scoped=true"
import script from "./SyllabusProgressDisplay.vue?vue&type=script&lang=js"
export * from "./SyllabusProgressDisplay.vue?vue&type=script&lang=js"
import style0 from "./SyllabusProgressDisplay.vue?vue&type=style&index=0&id=d3ecb84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ecb84c",
  null
  
)

export default component.exports